import * as React from "react";
import {
  FabllbackProviderProps,
  FallbackContextType,
  FallbackType,
} from "../../models/context";

export const FallbackContext = React.createContext<FallbackContextType>({
  updateFallback: () => {},
});

export const FabllbackProvider: React.FC<FabllbackProviderProps> = ({
  children,
}) => {
  const [fallback, setFallback] = React.useState<FallbackType>(null);

  const updateFallback = React.useCallback((fallback: FallbackType) => {
    setFallback(() => fallback);
  }, []);

  const renderChildren = React.useMemo(() => children, [children]);

  return (
    <FallbackContext.Provider value={{ updateFallback }}>
      <React.Suspense fallback={fallback}>{renderChildren}</React.Suspense>
    </FallbackContext.Provider>
  );
};